export default __webpack_public_path__ + "static/media/photo39.c81a717d.jpg";